import { TextareaAutosize } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: '#000E1C',
  height: '100%',
  padding: '40px 140px',

  '& h3': {
    color: theme.palette.global.white,
    marginTop: 48,
  },
  '& textarea': {
    color: '#E2E2E2',
    borderRadius: 8,
    minHeight: 90,
  },
}));

export const ContainerTextStyled = styled('div')({
  width: '90%',
  backgroundColor: '#171D2D',
  padding: 16,
  marginTop: 16,
  marginLeft: 48,
  borderRadius: 8,
  color: '#E2E2E2',
});

export const EditIconStyled = styled('div')({
  minWidth: 70,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
});

export const TextStyled = styled(TextareaAutosize)(({ theme }) => ({
  backgroundColor: 'transparent',
  fontFamily: 'montserrat',
  fontSize: 15,
  width: '100%',
  borderRadius: 8,
  border: `1px solid ${theme.palette.secondary.main}`,
  color: 'red',
  padding: '16px',
}));

export const ContainerButtonsStyled = styled('div')({
  justifyContent: 'space-between',
  marginTop: 32,
});

export const BoxButtonsStyled = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  '& button': {
    color: '#E2E2E2',
    fontWeight: 'bold',
  },
  '& h4': {
    color: '#E2E2E2',
    '&:hover': {
      color: alpha('#E2E2E2', 0.8),
      cursor: 'pointer',
    },
  },
}));
